module.exports = __webpack_public_path__ + "img/qrcode_wechat.c97ec380.jpeg";